/* eslint-disable */
export const formatValue = (value) => {
  const numberValue = Number(value);

  if (numberValue >= 1000000) {
    return `${(numberValue / 1000000).toFixed(numberValue % 1000000 === 0 ? 0 : 2)}M`;
  } else if (numberValue >= 1000) {
    return `${(numberValue / 1000).toFixed(numberValue % 1000 === 0 ? 0 : 2)}K`;
  }
  return numberValue.toString();
};
